import Gardenloft1 from '../../Media/Produk/Garden Loft.webp'
import Gardenloft2 from '../../Media/Produk/Garden Loft.webp'



const Gardenloftimages =[
    Gardenloft1,Gardenloft2
]

export default Gardenloftimages;